import {
  frameThickness,
  glassHingeWidth,
  glassHingeHeight,
  glassLockWidth,
  glassLockHeight,
} from '@/shared/config/model-constants'
import type { ModelData } from '@/shared/stores/model-utils'

export const model1_4InitialModel: ModelData = {
  name: 'Variant 4',
  modelId: 'model1_4',
  type: 'DOOR',
  description: 'Variant 4',
  width: 1700,
  height: 2500,
  photoId: null,
  serviceNames: [],
  serviceIds: [],
  parameters: [
    // Frame profiles
    {
      positionId: 'top_frame_profile',
      type: 'PROFILE',
      width: 1700,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 0, y: 0, z: 0 },
    },
    {
      positionId: 'bottom_left_frame_profile',
      type: 'PROFILE',
      width: 400,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 0, y: 2440, z: 0 },
    },
    {
      positionId: 'bottom_right_frame_profile',
      type: 'PROFILE',
      width: 400,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 1300, y: 2440, z: 0 },
    },
    {
      positionId: 'left_frame_profile',
      type: 'PROFILE',
      width: frameThickness,
      height: 2500,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 0, y: 0, z: 0 },
    },
    {
      positionId: 'right_frame_profile',
      type: 'PROFILE',
      width: frameThickness,
      height: 2500,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 1640, y: 0, z: 0 },
    },
    // Glass panels
    {
      positionId: 'left_glass_panel',
      type: 'GLASS',
      width: 340,
      height: 2380,
      thickness: 6,
      color: 'rgba(0, 0, 255, 0.1)',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: frameThickness, y: frameThickness, z: 0 },
    },
    {
      positionId: 'top_center_glass_panel',
      type: 'GLASS',
      width: 900,
      height: 380,
      thickness: 6,
      color: 'rgba(0, 0, 255, 0.1)',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 400, y: frameThickness, z: 0 },
    },
    {
      positionId: 'center_door_glass_panel',
      type: 'GLASS',
      width: 900,
      height: 2060,
      thickness: 6,
      color: 'rgba(0, 0, 255, 0.1)',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 400, y: 440, z: 0 },
      hardware: {
        handles: [
          {
            positionId: 'vertical_handle',
            type: 'VERTICAL_HANDLE',
            width: 30,
            height: 1300,
            thickness: 10,
            color: '#ffffff',
            material: '',
            materialId: null,
            position: {
              x: 900 - (frameThickness + 30),
              y: 380,
              z: 10,
            },
          },
        ],
        hinges: [
          {
            positionId: 'door_2_right_top_hinge_1',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            position: {
              x: -glassHingeWidth / 2,
              y: -glassHingeHeight / 2,
              z: 10,
            },
          },
          {
            positionId: 'door_2_right_bottom_hinge_2',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            position: {
              x: 0,
              y: 2060 - glassHingeHeight,
              z: 10,
            },
          },
        ],
        locks: [
          {
            positionId: 'door_2_left_lock',
            type: 'LOCK',
            width: glassLockWidth,
            height: glassLockHeight,
            thickness: 10,
            color: '#C0C0C0',
            position: {
              x: 900 - glassLockWidth,
              y: 2060 - glassLockHeight,
              z: 10,
            },
          },
        ],
      },
    },
    {
      positionId: 'right_glass_panel',
      type: 'GLASS',
      width: 340,
      height: 2380,
      thickness: 6,
      color: 'rgba(0, 0, 255, 0.1)',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 1300, y: frameThickness, z: 0 },
    },
  ],
  doorConfiguration: {
    type: 'single_door',
    totalDoorWidth: 900,
    individualDoorWidth: [900],
    totalHandles: 1,
    openingDirection: 'inward_and_outward_swing',
    hingePosition: 'RIGHT',
  },
}
